// Import API call
import { strichCall } from './APICoreCalls';

// Import the stored app config getter
import { GetAppConfig } from "global/config/AppConfigStore";



// Helper function for conditional logging
const debugLog = (...args) => {

    // Read the loaded runtime config only when this function is called
    const config = GetAppConfig();

    // Read the configured debug flag
    const debugFlag = config?.debug === true;

    // Only log when enabled
    if (debugFlag) {

        // Pass everything through to console.log
        console.log(...args);

    }

};



// ********************************************************************** /
// UserContext Functions - Get once on site load (at log in or page refresh)

export async function getAccountLastUpdated(token) {

    // Get the account last updated markers from the API
    const response = await strichCall("GET", "accounts/last_updated", token);

    // Log the API response when debug logging is enabled - remmed the below out because it's pretty noisy and doesn't tell us much - Ben
    //debugLog("getAccountLastUpdated response:", response);

    // Return the response
    return response;

}

export async function getUserAccountData(token, set_account_details) {

    // Get the account data from the API
    const response = await strichCall("GET", "accounts/account", token);

    // Log the API response when debug logging is enabled
    debugLog("getUserAccountData response:", response);

    // Set the account details when a setter has been supplied
    if (response?.success && set_account_details) {

        set_account_details(response["results"]);

    }

    // Return the response
    return response;

}

// Get the connections and return the response because we need to amend the data before setting it in state
export async function getConnections(token) {

    const response = await strichCall("GET", "connections/connections", token);

    debugLog("Get Connections Response:", response);

    return response;

}

export function getStores(token, set_stores) {

    strichCall("GET", "stores/stores", token)
        .then((response) => {
            debugLog("Stores Response:", response);
            set_stores(response["results"]);
        })

    return;
}

export function getShippingMethods(token, set_shipping_methods) {

    strichCall("GET", "shipping/shipping_methods", token)
        .then((response) => {
            debugLog("Shipping Methods Response:", response);
            set_shipping_methods(response["results"]);
        })

    return;
}

// Get core order statuses
export function getOrderStatuses(token, set_order_statuses) {

    strichCall("GET", "core/order_statuses", token)
        .then((response) => {
            debugLog("Order Statuses Response:", response);
            set_order_statuses(response["results"]);
        })

    return;
}

// Get core currencies
export function getCoreCurrencies(token, set_currencies) {

    strichCall("GET", "core/currencies", token)
        .then((response) => {
            debugLog("Core Currencies Response:", response);
            set_currencies(response["results"]);
        })

    return;
}

// Get core countries
export function getCoreCountries(token, set_countries) {

    strichCall("GET", "core/countries?inc_flags=Y", token)
        .then((response) => {
            debugLog("Core Countries Response:", response);
            set_countries(response["results"]);
        })

    return;
}

// Get core regions (groups of countries )
export function getCoreRegions(token, set_regions) {

    strichCall("GET", "core/regions", token)
        .then((response) => {
            debugLog("Core Regions Response:", response);
            set_regions(response["results"]);
        })

    return;
}

// Get the countries avaiable for fulfilment
export function getFulfilmentCountries(token, set_fulfilment_countries) {

    strichCall("GET", "core/countries?fulfilment=Y", token)
        .then((response) => {
            debugLog("Fulfilment Countries Response: ", response);
            set_fulfilment_countries(response["results"]);
        })

    return;
}

// ********************* UserContext Functions END ********************** /
// ********************************************************************** /



// Get the core terms and conditions
export async function getTerms(token, documentType) {

    debugLog("core/terms?document_type=" + documentType);

    const response = await strichCall("GET", "core/terms?document_type=" + documentType, token);

    debugLog("Terms Response:", response);

    return response;

}




// Request Change Account Email Address
export async function requestEmailChange(token) {

    const response = await strichCall("GET", "accounts/request_email_change", token);

    //debugLog("requestEmailChange:", response);

    return response;

}


// Update PayPal payout email
export async function updatePayPalPayoutEmail(token, paypal_payout_email) {

    // Build the payload 
    let update_data = [];
    update_data["paypal_payout_email"] = paypal_payout_email;

    // Convert to JSON
    let postdata = JSON.stringify(Object.assign({}, update_data));

    const response = await strichCall("PUT", "accounts/account", token, postdata);

    debugLog("Update PayPal Payout Email Response:", response);

    return response;

}


// Update account settings
export async function updateAccountSettings(token, updated_settings) {
   
    // Convert the data to correct format for the call
    const updatedAccountSettings = JSON.stringify(Object.assign({}, updated_settings))

    const response = await strichCall("POST", "accounts/settings", token, updatedAccountSettings);

    debugLog("Update Account Settings Response:", response, " Post Data: ", updatedAccountSettings);

    return response;

}


// Get the user's account subscriptiion details
export async function getAccountSubscriptions(token) {

    const response = await strichCall("GET", "accounts/subscriptions", token);

    debugLog("Get Account Subscriptions:", response);

    return response;

}

// Add or Update Account Subscription
export async function addUpdateAccountSubscription(token, payload) {

    // Convert the data to correct format for the call
    const postData = JSON.stringify(Object.assign({}, payload))

    const response = await strichCall("POST", "accounts/subscriptions", token, postData);

    debugLog("Upgrade Subscription Level Response:", response);

    return response;

}

// Update Account Subscription (auto renew on/off) 
export async function updateAccountSubscription(token, payload) {

    // Convert the data to correct format for the call
    const postData = JSON.stringify(Object.assign({}, payload))

    const response = await strichCall("PUT", "accounts/subscriptions", token, postData);

    debugLog("Update Subscription Response:", response);

    return response;

}




// ORDERS //

// Get Open Orders
export async function getOpenOrders(token) {

    const response = await strichCall("GET", "orders/open", token);

    debugLog("Get Open Orders Response:", response);

    return response;

}

// Get Orders - now takes  from=  & to = paramenters
export async function getOrders(token, fromDate, toDate) {

    //console.log("API from date: ", fromDate);
    //console.log("API to date: ", toDate);

    const response = await strichCall("GET", "orders/orders?from=" + fromDate + "&to=" + toDate, token);

    debugLog("Get Orders Response:", response);

    return response;

}

// Get specific order details
export async function getOrder(token, orderId) {

    debugLog("orders/order?order_id=", orderId);

    const response = await strichCall("GET", "orders/order?order_id=" + orderId, token);

    debugLog("Get Order Details Response:", response);

    return response;

}

// Get specific order details by order UID
export async function getOrderByUID(token, orderUid) {

    debugLog("orders/order?order_uid=", orderUid);

    //trim the orderUid to remove any whitespace
    
    orderUid = orderUid.trim();

    const response = await strichCall("GET", "orders/order?uid=" + orderUid, token);

    debugLog("Get Order Details By UID Response:", response);

    return response;

}

// Update Order - force_overwrite (on click save button so has to be a manual update, therefore force is appropriate)
export async function updateOrder(token, updated_order_details) {

    //console.log("updated_order_details: ", updated_order_details);

    // Convert the data to correct format for the call
    const updatedOrderDetails = JSON.stringify(Object.assign({}, updated_order_details))

    try {

        const response = await strichCall("POST", "orders/order", token, updatedOrderDetails);

        debugLog("Update Order Response:", response);

        // If response?.results is null or undefined, fall back to response - depending on what the response is 
        return response;


    } catch (error) {

        //console.error(" API Error:", error);
        return { success: false, error: "Failed to update order." };

    }
}

// Refund order
export async function refundOrder(token, refund_details) {

    // Convert the data to correct format for the call
    const refundDetails = JSON.stringify(Object.assign({}, refund_details));

    // Call the refund order route
    const response = await strichCall("POST", "orders/refund", token, refundDetails);

    // Log the response when debug logging is enabled
    debugLog("Refund Order Response:", response);

    // Return the response
    return response;

}

// Cancel order
export async function cancelOrder(token, cancel_details) {

    // Convert the data to correct format for the call
    const cancelDetails = JSON.stringify(Object.assign({}, cancel_details));

    // Call the cancel order route
    const response = await strichCall("POST", "orders/cancel", token, cancelDetails);

    // Log the response when debug logging is enabled
    debugLog("Cancel Order Response:", response);

    // Return the response
    return response;

}


// Update order status
export async function updateOrderStatus(token, updated_status) {

    // Convert the data to correct format for the call
    const updatedStatus = JSON.stringify(Object.assign({}, updated_status))

    const response = await strichCall("PUT", "orders/order", token, updatedStatus);

    return response;

}

// Calculate order earning
export async function calculateOrderEarnings(token, orderDetails) {

    // Convert the order details into the API payload
    const orderPayload = JSON.stringify(Object.assign({}, orderDetails));

    try {

        // Ask the order route to calculate earnings from the mock order
        const response = await strichCall("POST", "orders/order?calc_earnings=Y", token, orderPayload);

        // Log the API response when debug logging is enabled
        debugLog("calculateOrderEarnings response: ", response);

        // Return the API response
        return response;

    } catch (error) {

        // Log the API error
        console.error("API Error:", error);

        // Return a standard failure response
        return { success: false, error_message: "Failed to calculate order earnings." };

    }

}


// Add New Order
export async function addNewOrder(token, new_order_details) {

    //debugLog(new_order_details);

    // Convert the data to correct format for the call
    const newOrderDetails = JSON.stringify(Object.assign({}, new_order_details));

    //debugLog(newOrderDetails);

    try {

        const response = await strichCall("POST", "orders/order", token, newOrderDetails);

        debugLog("addNewOrder response: ", response);

        return response;

    } catch (error) {

        console.error(" API Error:", error);

        return { success: false, error: "Failed to add order." };

    }
}
// Delete order
export async function deleteOrder(token, orderID, venueOrderID) {

    const response = await strichCall("DELETE", "orders/order?order_id=" + orderID + "&venue_order_id=" + venueOrderID, token);

    debugLog("Order: ", orderID, " Delete Order Response: ", response);

    return response;

}

// Delete order item
export async function deleteOrderItem(token, orderID, orderItemID) {

    const response = await strichCall("DELETE", "orders/order_item?order_id=" + orderID + "&item_id=" + orderItemID, token);

    debugLog("Delete Order Item Response:", response);

    return response;

}

// Get the fulfilment services (shipping services) for fulfilment requests by country
export async function getFulfilmentServicesBy(token, country) {

    // Create with the country if there is one
    const endPoint = country ? "core/fulfilment_services?country=" + country : "core/fulfilment_services";

    const response = await strichCall("GET", endPoint, token);

    debugLog("Get Fulfilment Services Response:", response);

    return response;

}

// Request Fulfilment Cost
export async function requestFulfilmentCost(token, payload) {

    // Convert to JSON
    const postdata = JSON.stringify(Object.assign({}, payload))

    const response = await strichCall("POST", "orders/get_fulfilment_cost", token, postdata);

    debugLog("getFulfilmentCost Response:", response);

    return response;

}

// Send order for fulfilment
export async function sendForFulfilment(token, payload) {

    // Convert to JSON
    const postdata = JSON.stringify(Object.assign({}, payload))

    const response = await strichCall("POST", "orders/send_for_fulfilment", token, postdata);

    debugLog("send for fulfilment response: ", response);

    return response;

}

// Upload print data
export async function uploadPrintData(token, order_id, order_item_id, payload) {

    // Convert to JSON
    let postdata = JSON.stringify(Object.assign({}, payload))

    try {

        const response = await strichCall("POST", "orders/set_print_data?order_id=" + order_id + "&order_item_id=" + order_item_id, token, postdata);

        debugLog("Upload print data response: ", response);

        return response;

    } catch (error) {

        console.error(" API Error:", error);

        return { success: false, error: "Failed to upload print data." };

    }
}





// CONNECTIONS //

// Get connections
export async function fetchConnectionsData(token, connection_id) {

    // Create endpoint
    const endpoint = connection_id ? "connections/connections?connection_id=" + connection_id : "connections/connections";

    const response = await strichCall("GET", endpoint, token);

    debugLog("Get Connection Response:", response);

    return response;

}

// Update Connection
export async function updateConnection(token, updated_connection_details) {
   
    // Convert the data to correct format for the call
    const updatedConnectionData = JSON.stringify(Object.assign({}, updated_connection_details))

    const response = await strichCall("PUT", "connections/connections", token, updatedConnectionData);

    debugLog("Update Connection Response:", response, " Post Data: ", updatedConnectionData);

    return response;

}

// Update Connection (Store) Settings
export async function updateConnectionSettings(token, updated_settings) {
   
    // Convert the data to correct format for the call
    const updatedConnectionSettings = JSON.stringify(Object.assign({}, updated_settings))

    const response = await strichCall("POST", "connections/settings", token, updatedConnectionSettings);

    debugLog("Update Connection Settings Response:", response, " Post Data: ", updatedConnectionSettings);

    return response;

}



// Add New Connection
export async function addNewConnection(token, new_connection_details) {

    // Convert the data to correct format for the call
    const newConnectionDetails = JSON.stringify(Object.assign({}, new_connection_details))

    const response = await strichCall("POST", "connections/connections", token, newConnectionDetails);

    debugLog("Adding New Connection Response: ", response, " Post Data: ", newConnectionDetails);

    return response;

}

// Check connection alias
export async function checkConnectionAlias(token, alias) {

    // Encode the alias for safe use in the query string
    const encodedAlias = encodeURIComponent(alias);

    // Make the API call
    const response = await strichCall("GET", "connections/check_alias?alias=" + encodedAlias, token);

    debugLog("Check Connection Alias Response:", response);

    return response;

}

// Update connection alias
export async function updateConnectionAlias(token, connection_id, new_alias) {

    // Encode the alias for safe use in the query string
    const encodedAlias = encodeURIComponent(new_alias);

    // Make the API call
    const response = await strichCall("PUT", "connections/update_alias?connection_id=" + connection_id + "&alias=" + encodedAlias, token);

    debugLog("Update Connection Alias:", response);

    return response;

}

// Get connection pages
export async function fetchConnectionPages(token, connection_id) {

    const response = await strichCall("GET", "connections/pages?connection_id=" + connection_id, token);

    debugLog("Get Connection Pages Response:", response);

    return response;

}

// Add Connection Page
export async function addNewConnectionPage(token, connection_id, new_connection__page_details) {

    // Convert the data to correct format for the call
    const newConnectionPage = JSON.stringify(Object.assign({}, new_connection__page_details))

    const response = await strichCall("POST", "connections/pages?connection_id=" + connection_id, token, newConnectionPage);

    debugLog("Adding New Connection Page Response: ", response, " Post Data: ", newConnectionPage);

    return response;

}

// Update connection page
export async function updateConnectionPage(token, connection_id, page) {

    // Convert the data to correct format for the call
    const pageData = JSON.stringify(Object.assign({}, page))

    // Make the API call
    const response = await strichCall("PUT", "connections/pages?connection_id=" + connection_id, token, pageData);

    debugLog("Update Connection Page Response:", response, " Post Data: ", pageData);

    return response;

}

// Delete connection page
export async function deleteConnectionPage(token, connection_id, page) {

    const response = await strichCall("DELETE", "connections/pages?connection_id=" + connection_id + "&page_id=" + page.id , token);

    debugLog("Delete Connection Page Response:", response);

    return response;

}

// Delete connection
export async function deleteConnection(token, connection_id) {

    const response = await strichCall("DELETE", "connections/connections?connection_id=" + connection_id , token);

    debugLog("Delete Connection Response:", response);

    return response;

}

export async function deleteConnectionShippingMethod(token, connection_id, shipping_method_code) {

    const response = await strichCall("DELETE", "connections/shipping_methods?connection_id=" + connection_id + "&shipping_method_code=" + shipping_method_code, token);

    debugLog("Delete Connection Shipping Method Response:", response);

    return response;

}


// Call to render email template for a connection
export async function getEmailTemplateRender(token, order_id, template_type) {

    const response = await strichCall("GET", "documents/order?order_id=" + order_id + "&template=" + template_type, token);

    debugLog("Get Email Template Render Response:", response);

    return response;

}





// TRANSACTIONS //

// Get Transactions
export async function getTransactions(token) {

    const response = await strichCall("GET", "accounts/transactions", token);

    debugLog("Get Transactions Response:", response);

    return response;

}

// Get Transactions by Date Range
export async function getTransactionsByDateRange(token, fromDate, toDate) {

    debugLog("api call from date: ", fromDate, " - to date: ", toDate);

    // Make the params list
    const paramsList = fromDate && toDate ? "?from=" + fromDate + "&to=" + toDate : fromDate ? "?from=" + fromDate : toDate ? "?to=" + toDate : "";



    const response = await strichCall("GET", "accounts/transactions" + paramsList, token);

    debugLog("Get Transactions by Date Range Response:", response);

    return response;

}

// Get Payouts
export async function getPayouts(token) {

    const response = await strichCall("GET", "accounts/payouts", token);

    debugLog("Get Payouts Response:", response);

    return response;

}

// Get specific payout details
export async function getPayout(token, payoutId) {

    const response = await strichCall("GET", "accounts/payouts?payout_id=" + payoutId, token);

    debugLog("Get Payout Response:", response);

    return response;

}

// Request a payout
export async function requestPayout(token, method = "paypal") {

    const response = await strichCall("POST", "accounts/payouts?payout_method=" + method, token);

    debugLog("Request Payout Response:", response);

    return response;

}



// IMAGES (BUCKET) //

// Get Images
export async function getImages(token) {

    const response = await strichCall("GET", "images/image", token);

    debugLog("Get Images Response:", response);

    return response;

}

// Get a single image including any associated child bucket items
export async function getImage(token, image_id) {

    const response = await strichCall("GET", "images/image?image_id=" + image_id, token);

    debugLog("Get Image Response:", response);

    return response;

}

// Update Image
export async function updateImage(token, image_data) {

    // Convert the data to correct format for the call
    const imageData = JSON.stringify(Object.assign({}, image_data))

    const response = await strichCall("PUT", "images/image", token, imageData);

    debugLog("Update Image Response:", response);

    return response;

}

// Add Image
export async function addNewImage(token, new_image_data, thumbnail_size) {

    // Convert the data to correct format for the call
    const newImageData = JSON.stringify(Object.assign({}, new_image_data))

    const response = await strichCall("POST", "images/image?thumbnail_size=" + thumbnail_size, token, newImageData);

    debugLog("Add Image Response:", response);

    return response;

}

// Delete Image
export async function deleteImage(token, image_id) {

    const response = await strichCall("DELETE", "images/image?image_id=" + image_id, token);

    debugLog("Delete Image Response:", response);

    return response;

}



// RATE CARD //

// Get the rate card
export async function getRateCard(token) {
 
    const response = await strichCall("GET", "pod/rate_card?inc_placeholders=N", token);

    debugLog("Get Rate Card Response:", response);

    return response;

}

// Get the Subscription Packages
export async function getSubscriptionPackages(token, set_subscription_packages, currency = "") {

    // Build the endpoint with an account currency when supplied
    const endpoint = currency ? "core/subscription_packages?currency=" + encodeURIComponent(currency) : "core/subscription_packages";

    // Get the subscription packages
    const response = await strichCall("GET", endpoint, token);

    if (response.success && set_subscription_packages) {

        set_subscription_packages(response.results);

    }

    debugLog("Get Subscription Packages Response:", response);

    return response;

}

// Get the Subscription Levels
export async function getSubscriptionLevels(token, set_subscription_levels) {

    // Get the subscription levels
    const response = await strichCall("GET", "core/subscription_levels", token);

    if (response.success && set_subscription_levels) {

        set_subscription_levels(response.results);

    }

    debugLog("Get Subscription Levels Response:", response);

    return response;

}



///////////////



// POD DESIGN PRODUCTS AND TEMPLATES //

// Get the POD designs (headers)
export async function getPodDesigns(token, designOrTemplate) {

    const response = await strichCall("GET", "pod/" + designOrTemplate + "s", token);

    debugLog("Get POD " + designOrTemplate + "s Response:", response);

    return response;

}

// Get the POD design details - Set take_form _design flag to N because we don't want the product roles being pre filled with design data (scale, bg colour, position etc)
export async function getPodDesign(token, designOrTemplate, id) {

    const response = await strichCall("GET", "pod/" + designOrTemplate + "s?" +  designOrTemplate + "_id=" + id + "&take_from_design=N", token);

    debugLog("Get POD " + designOrTemplate + " Response:", response);

    return response;

}

// Add new POD design
export async function addPodDesign(token, new_pod_design_data) {

    // Convert the data to correct format for the call
    const newPodDesignData = JSON.stringify(Object.assign({}, new_pod_design_data))

    const response = await strichCall("POST", "pod/designs", token, newPodDesignData);

    debugLog("Add POD Design Response:", response, " Post Data: ", newPodDesignData);

    return response;

}

// Add new POD Template
export async function addPodTemplate(token, new_pod_template_data) {

    // Convert the data to correct format for the call
    const newPodTemplateData = JSON.stringify(Object.assign({}, new_pod_template_data))

    const response = await strichCall("POST", "pod/templates", token, newPodTemplateData);

    debugLog("Add POD Template Response:", response, " Post Data: ", newPodTemplateData);

    return response;

}

// Delete POD Design OR Template
export async function deletePodDesign(token, designOrTemplate, id) {

    const response = await strichCall("DELETE", "pod/" + designOrTemplate + "s?" + designOrTemplate + "_id=" + id, token);

    debugLog("Delete POD " + designOrTemplate + " Response:", response);

    return response;

}

// Update POD Design Roles 
export async function updatePodDesignRoles(token, pod_design_id, updated_pod_design_roles_data) {

    //console.log("updated_pod_design_roles_data: ", updated_pod_design_roles_data);

    // Convert the data to correct format for the call
    const postData = JSON.stringify(updated_pod_design_roles_data);

    const response = await strichCall("POST", "pod/design_roles?design_id=" + pod_design_id, token, postData);

    debugLog("Update Pod Design Roles Response:", response, " Post Data: ", postData);

    return response;

}

// Update POD Template Roles 
export async function updatePodTemplateRoles(token, pod_template_id, updated_pod_template_roles_data) {

    //console.log("updated_pod_template_roles_data: ", updated_pod_template_roles_data);

    // Convert the data to correct format for the call
    const postData = JSON.stringify(updated_pod_template_roles_data);

    const response = await strichCall("POST", "pod/template_roles?template_id=" + pod_template_id, token, postData);

    debugLog("Update Pod Template Roles Response:", response, " Post Data: ", postData);

    return response;

}

// Get POD Design OR Template Products
export async function getPodDesignProducts(token, designOrTemplate, pod_design_id) {

    // Get the complete configured product hierarchy for this design or template
    const response = await strichCall("GET", "pod/" + designOrTemplate + "_products?" + designOrTemplate + "_id=" + pod_design_id, token);

    debugLog("Get Pod " + designOrTemplate + " Products Response:", response);

    return response;

}

// Update POD Design OR Template Products 
export async function updatePodDesignProducts(token, designOrTemplate, pod_design_id, updated_pod_design_products_data) {

    debugLog("updated_pod_design_products_data: ", updated_pod_design_products_data);

    // Convert the data to correct format for the call
    const postData = JSON.stringify(updated_pod_design_products_data);

    const response = await strichCall("POST", "pod/" + designOrTemplate + "_products?" + designOrTemplate + "_id=" + pod_design_id, token, postData);

    debugLog("Update Pod " + designOrTemplate + " Products Response:", response, " Post Data: ", postData);

    return response;

}

// Update POD Design OR Template Details
export async function updatePodDesignDetails(token, designOrTemplate, pod_design_id, updated_pod_design_data) {

    debugLog("updated_pod_design_data: ", updated_pod_design_data);
    //console.log("token, designOrTemplate, pod_design_id, updated_pod_design_data: ", token, designOrTemplate, pod_design_id, updated_pod_design_data);

    // Convert the data to correct format for the call
    const updatedPodDesignData = JSON.stringify(Object.assign({}, updated_pod_design_data))

    const response = await strichCall("PUT", "pod/" + designOrTemplate + "s?" + designOrTemplate + "_id=" + pod_design_id, token, updatedPodDesignData);

    debugLog("Update Pod " + designOrTemplate + " Details Response:", response, " Post Data: ", updatedPodDesignData);

    return response;

}

// Update POD Design OR Template Translations 
export async function updatePodDesignTranslations(token, designOrTemplate, pod_design_id, updated_pod_design_translations_data) {

    // Convert the data to correct format for the call
    const postData = JSON.stringify(updated_pod_design_translations_data);

    const response = await strichCall("POST", "pod/" + designOrTemplate + "_translations?" + designOrTemplate + "_id=" + pod_design_id, token, postData);

    debugLog("Update Pod " + designOrTemplate + " Translations Response:", response, " Post Data: ", postData);

    return response;

}

// Update a POD Design OR Template Product Translations - NOT TESTED YET!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export async function updatePodDesignProductTranslations(token, designOrTemplate, pod_design_id, configured_product_id, updated_pod_design_translations_data) {

    // Convert the data to correct format for the call
    const postData = JSON.stringify(updated_pod_design_translations_data);

    const response = await strichCall("POST", "pod/" + designOrTemplate + "_product_translations?" + designOrTemplate + "_id=" + pod_design_id + "&product_id=" + configured_product_id, token, postData);

    debugLog("Update Pod " + designOrTemplate + "Product Translations Response:", response, " Post Data: ", postData);

    return response;

}


// design_product_roles
// design_product_variants 
// template_product_roles
// template_product_variants 



// Get canonical strich POD products (headers) *********************************** ADD COUNTRY FOR THIS CALL FROM STORE COUNTRY
export async function getPodProducts(token, country_code) {

    const response = await strichCall("GET", "pod/pod_products?country=" + country_code, token);

    debugLog("Get Canonical POD Products Response:", response);

    return response;

}

// Get canonical strich product details *********************************** &venue_connid=1 ??
export async function getPodProduct(token, canonical_product_sku, include_place_holders, country_code) {

    //const response = await strichCall("GET", "pod/pod_products?product_id=" + canonical_product_id, token);
    const response = await strichCall("GET", "pod/pod_products?pod_product_sku=" + canonical_product_sku + "&inc_placeholders=" + include_place_holders + "&country=" + country_code, token);

    // Shush
    debugLog("Get Canonical POD Product Details Response: " + include_place_holders, response);

    return response;

}

// Get canonical products prices in specific currency
export async function getPodProductPrices(token, countryCode) {

    const response = await strichCall("GET", "pod/pod_product_prices?country=" + countryCode, token);

    // Shut up!
     debugLog("Get Canonical POD Product Prices Response: " + countryCode, response);

    return response;

}

// Get design products (canonical products assigned to a design)
export async function getDesignProducts(token, id) {

    const response = await strichCall("GET", "pod/design_products?design_id=" + id, token);

    debugLog("Get Design Products Response:", response);

    return response;

}

// Add a Design Product (assign a canonical product to a design)
export async function addDesignProduct(token, design_id, product_payload) {

    // Convert the data to correct format for the call
    const productPayload = JSON.stringify(Object.assign({}, product_payload))

    const response = await strichCall("POST", "pod/design_products?design_id=" + design_id, token, productPayload);

    debugLog("Add Design Product Response:", response, " Post Data: ", productPayload);

    // Include the product id in the repsonse
    return { ...response, id: productPayload.product_id };

}

// Remove a Design or Template Product
export async function deleteDesignProduct(token, designOrTemplate, design_or_template_id, configured_product_id) {

    const response = await strichCall("DELETE", "pod/" + designOrTemplate + "_products?" + designOrTemplate + "_id=" + design_or_template_id + "&product_id=" + configured_product_id, token);

    debugLog("Delete Design Product Response:", response);

    // Include the configured product id in the response
    return { ...response, id: configured_product_id };

}

export async function updateDesignProduct(token, designOrTemplate, design_id, product_sku, payload) {

    // WAITING FOR BEN TO ADD TRANSLATION UPDATES
    //console.log("design_id = ", design_id, " product_sku = ", product_sku, " payload = ", payload);

    // Convert the data to correct format for the call
    //const productPayload = JSON.stringify(Object.assign({}, payload));
    const productPayload = JSON.stringify(payload);

    const response = await strichCall("PUT", "pod/" + designOrTemplate + "_products?" + designOrTemplate + "_id=" + design_id + "&product_sku=" + product_sku, token, productPayload);

    debugLog("Update designOrTemplate Product Response:", response, " Post Data: ", productPayload);

    // Include the product id in the repsonse
    return { ...response, id: productPayload.product_id };

}

// Get the POD design product details
export async function getDesignProductDetails(token, design_id, product_sku) {

    const response = await strichCall("GET", "pod/design_products?design_id=" + design_id + "&pod_product_sku=" + product_sku, token);

    debugLog("Get Design Product Details Response:", response);

    return response;

}

// Get one configured POD design or template product's image rows
export async function getPodDesignProductImages(token, designOrTemplate, id, configured_product_id) {

    const response = await strichCall("GET", "pod/" + designOrTemplate + "_product_images?" + designOrTemplate + "_id=" + id + "&product_id=" + configured_product_id, token);

    debugLog("Get " + designOrTemplate + " Product Images Response: ", configured_product_id, response);

    return response;

}

// Update POD Design OR Template Product Images
export async function updatePodDesignProductImages(token, designOrTemplate, id, configured_product_id, payload) {

    // Convert the data to correct format for the call
    const productImagesPayload = JSON.stringify(payload);

    const response = await strichCall("POST", "pod/" + designOrTemplate + "_product_images?" + designOrTemplate + "_id=" + id + "&product_id=" + configured_product_id, token, productImagesPayload);

    debugLog("Update " + designOrTemplate + " Product Images Response: ", configured_product_id, response, " Post Data: ", productImagesPayload);

    // Include the configured product id in the response
    return { ...response, id: configured_product_id };

}

// Update a Design Product Roles (amend centre x and y, scale x and y and background colour) where payload is an array of roles
export async function updatePodDesignProductRoles(token, designOrTemplate, id, configured_product_id, payload) {

    //console.log("design_id = ", id, " configured_product_id = ", configured_product_id, " payload = ", payload);

    // Convert the data to correct format for the call
    //const productRolesPayload = JSON.stringify(Object.assign({}, payload))
    const productRolesPayload = JSON.stringify(payload);

    //console.log("productRolesPayload: ", productRolesPayload);

    const response = await strichCall("POST", "pod/" + designOrTemplate + "_product_roles?" + designOrTemplate + "_id=" + id + "&product_id=" + configured_product_id, token, productRolesPayload);

    debugLog("Update " + designOrTemplate + " Product Roles Response: ", configured_product_id, response, " Post Data: ", productRolesPayload);

    // Include the configured product id in the response
    return { ...response, id: configured_product_id };

}



// Update product variants (not used yet) but there is a separate call for it



// design_product_variants ?design_id, &product_sku, GET has optional variant_id (optional), DELETE needs variant_id, PUT and POST require postdata
// POST adds, PUT updates and DELETE removes
// GET variant details for design pod product
export async function getDesignProductVariantDetails(token, design_id, configured_product_id) {

    //console.log(design_id);
    //console.log(configured_product_id);

    const response = await strichCall("GET", "pod/design_product_variants?design_id=" + design_id + "&product_id=" + configured_product_id, token);

    debugLog("Get Design Product Variant Details Response:", response);

    return response;

}
// Add / Update Design Product Variants
export async function updateDesignProductVariants(token, design_id, configured_product_id, product_variant_data) {

    //console.log("new_image_data: ", new_image_data);

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(Object.assign({}, product_variant_data))

    const response = await strichCall("POST", "pod/design_product_variants?design_id=" + design_id + "&product_id=" + configured_product_id, token, postdata);

    debugLog("Update Design Product Variants Response:", response, " Post Data: ", postdata);

    return response;

}
// Delete Design Product Variant
export async function removeDesignProductVariant(token, design_id, configured_product_id, variant_id) {

    const response = await strichCall("DELETE", "pod/design_product_variants?design_id=" + design_id + "&product_id=" + configured_product_id + "&variant_id=" + variant_id, token);

    debugLog("Delete Design Product Variant Response:", response);

    return response;

}




// Generating cache_id for mockup images
export async function getCacheIdForMockupImageCustomProducts(token, payload) {

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(Object.assign({}, payload))

    const response = await strichCall("POST", "custom_products/print_area_plate?return_base64=N&return_cache_id=Y&dpi_only=N", token, postdata);

    //debugLog("getCacheIdForMockupImageCustomProducts Response:", response, " Post Data: ", postdata);

    return response;

}

// Generating mockup images
export async function getMockUpImageCustomProduct(token, payload, return_bucket_id = "N") {

    // Safely create the flag (must be Y or N)
    const return_bucket_id_flag = return_bucket_id === "Y" ? "Y" : "N";

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(Object.assign({}, payload))

    //const response = await strichCall("POST", "custom_products/generate_mockup?return_base64=N&return_url=Y&output_size=4000&return_bucket_id=" + return_bucket_id_flag, token, postdata);
    const response = await strichCall("POST", "custom_products/generate_mockup?return_base64=N&return_url=Y&return_bucket_id=" + return_bucket_id_flag, token, postdata);

    //debugLog("getMockUpImageCustomProduct Response:", response, " Post Data: ", postdata);

    return response;

}
// Add print data to order item
export async function setPrintData(token, order_id, order_item_id, payload) {

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(Object.assign({}, payload))

    const response = await strichCall("POST", "orders/set_print_data?order_id=" + order_id + "&order_item_id=" + order_item_id, token, postdata);

    debugLog("setPrintData Response:", response, " Post Data: ", postdata);

    return response;

}



// AI Generation //

// Get AI workflows
export async function getAIWorkflows(token){

    const response = await strichCall("GET", "ai/workflows", token);

    debugLog("getAIWorkflows Response:", response);

    return response;

}


// Add AI Generation Request To Queue
export async function addAIGenerationRequest(token, payload) {

    const postdata = JSON.stringify(Object.assign({}, payload));

    const response = await strichCall("POST", "ai/queue", token, postdata);

    debugLog("addAIGenerationRequest Response:", response, " Post Data: ", postdata);

    return response;

}

// Get AI Generation Queue
export async function getAIGenerationQueue(token) {

    const response = await strichCall("GET", "ai/queue", token);

    return response;
}

// Get AI Generation Queue Item
export async function getAIGenerationQueueItem(token, job_id) {

    const response = await strichCall("GET", "ai/queue?job=" + job_id, token);

    return response;
}

// Save an AI queue result and all associated files to the user's bucket
export async function saveAIGenerationQueueItemToBucket(token, job_id) {

    const response = await strichCall("POST", "ai/save_to_bucket?job=" + job_id, token);

    debugLog("saveAIGenerationQueueItemToBucket Response:", response);

    return response;
}

// Delete AI Generation Queue Item
export async function deleteAIGenerationQueueItem(token, job_id) {

    const response = await strichCall("DELETE", "ai/queue?job=" + job_id, token);

    debugLog("deleteAIGenerationQueueItem Response:", response);

    return response;

}

// Get AI Upscalers
export async function getAIUpscalers(token) {

    const response = await strichCall("GET", "ai/upscalers", token);

    if (!response || !response.results) {

        console.error("No upscalers found or response is invalid.");

        return [];

    } else {

        return response.results;
    }

}

// Fetch AI styles from the API and return a formatted list
// 'mode' can be either "express" or "advanced"
export async function getAIStyles(token, mode = "express") {

    //console.log("Fetching AI styles with mode:", mode); 

    // Call the API endpoint with provided token
    const response = await strichCall("GET", "ai/styles", token);

    // Handle invalid or empty responses
    if (!response?.results) {

        console.error("No styles found or response is invalid.");

        return [];

    }

    // Log the raw response for debugging
    debugLog("getAIStyles Response:", response);

    // Transform the raw results:
    // - Map to expected format
    // - Fallback to 'name' if 'display_name' is null
    // - Filter styles based on mode
    let styles = response.results
        .map(({ name, display_name, express }) => ({
            value: name,
            name: display_name || name,
            express,
        }))
        .filter(style =>
            mode === "advanced" ? true : style.express !== "N"
        ); 

    return styles;
}




// Custom Products MMM //

// Get Materials
export async function getCustomProductsMaterials(token) {

    const response = await strichCall("GET", "custom_products/materials", token);

    debugLog("Get Custom Products Materials Response:", response);

    return response;

}

// Get Methods
export async function getCustomProductsMethods(token) {

    const response = await strichCall("GET", "custom_products/methods", token);

    debugLog("Get Custom Products Methods Response:", response);

    return response;

}

// Get Modes
export async function getCustomProductsModes(token) {

    const response = await strichCall("GET", "custom_products/modes", token);

    debugLog("Get Custom Products Modes Response:", response);

    return response;

}

// Update Material
export async function updateAddCustomProductsMaterial(token, payload) {

    //console.log(payload);

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(Object.assign({}, payload))

    //console.log(postdata);

    const response = await strichCall("POST", "custom_products/materials", token, postdata);

    debugLog("Update Custom Products Material Response:", response);

    return response;

}

// Update Method
export async function updateAddCustomProductsMethod(token, payload) {

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(Object.assign({}, payload))

    const response = await strichCall("POST", "custom_products/methods", token, postdata);

    debugLog("Update Custom Products Method Response:", response);

    return response;

}

// Update Mode
export async function updateAddCustomProductsMode(token, payload) {

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(Object.assign({}, payload))

    const response = await strichCall("POST", "custom_products/modes", token, postdata);

    debugLog("Update Custom Products Mode Response:", response);

    return response;

}

// Delete Material
export async function deleteCustomProductsMaterial(token, id, payload) {

    const postdata = JSON.stringify(Object.assign({}, payload))

    const response = await strichCall("DELETE", "custom_products/materials", token, postdata);

    debugLog("Material ID: ", id, " Delete Material Response: ", response);

    return response;

}

// Delete Method
export async function deleteCustomProductsMethod(token, id, payload) {

    const postdata = JSON.stringify(Object.assign({}, payload))

    const response = await strichCall("DELETE", "custom_products/methods", token, postdata);

    debugLog("Method ID: ", id, " Delete Method Response: ", response);

    return response;

}

// Delete Mode
export async function deleteCustomProductsMode(token, id, payload) {

    const postdata = JSON.stringify(Object.assign({}, payload))

    const response = await strichCall("DELETE", "custom_products/modes", token, postdata);

    debugLog("Mode Order: ", id, " Delete Mode Response: ", response);

    return response;

}

// Get MMM Links
export async function getMMMLinks(token) {

    const response = await strichCall("GET", "custom_products/mmm_links", token);

    debugLog("Get Custom Products Links Response:", response);

    return response;

}

// Create Link MMM
export async function createMMMLink(token, material_id, method_id, mode_id, payload) {

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(payload);

    const response = await strichCall("POST", "custom_products/mmm_links?material_id=" + material_id + "&method_id=" + method_id + "&mode_id=" + mode_id, token, postdata);

    debugLog("Create Custom Products MMM Link Response:", response);

    return response;

}

// Delete Mode
export async function deleteMMMLink(token, material_id, method_id, mode_id) {

    const response = await strichCall("DELETE", "custom_products/mmm_links?material_id=" + material_id + "&method_id=" + method_id + "&mode_id=" + mode_id, token);

    debugLog("Delete Link Response: ", response);

    return response;

}

// Custom Products MMM End //


// Custom Products //

// Get Custom Products
export async function getCustomProducts(token) {

    const response = await strichCall("GET", "custom_products/products", token);

    debugLog("Get Custom Products Response:", response);

    return response;

}

// Get Custom Product
export async function getCustomProduct(token, product_code, incl_mockups = "N", incl_print_layouts = "N") {

    const response = await strichCall("GET", "custom_products/products?product_code=" + product_code + "&inc_mockups=" + incl_mockups + "&inc_print_layouts=" + incl_print_layouts, token);

    debugLog("Get Custom Product Response:", response);

    return response;

}


// Add New Custom Product
export async function addCustomProduct(token, custom_product_data) {

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(custom_product_data);

    const response = await strichCall("POST", "custom_products/products", token, postdata);

    //debugLog("Add New Custom Product Response:", response);

    return response;

}

// Update Existing Custom Product
export async function updateCustomProduct(token, custom_product_data) {

    //console.log("custom product data: ", custom_product_data);

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(custom_product_data);
    // const postdata = JSON.stringify(Object.assign({}, custom_product_data))

    //console.log("custom product postdata: ", postdata);    

    const response = await strichCall("POST", "custom_products/products?product_code=" + custom_product_data.code, token, postdata);

    debugLog("Update New Custom Product Response:", response, custom_product_data);

    return response;

}

// Delete Custom Product
export async function deleteCustomProduct(token, custom_product_code) {

    const response = await strichCall("DELETE", "custom_products/products?product_code=" + custom_product_code, token);

    //debugLog("Delete Custom Product Response:", response);

    return response;

}

// Get Custom Product Colourways
export async function getCustomProductColourways(token, custom_product_code, colourway_code = null) {

    // Build the endpoint for the product colourways call
    let endpoint = "custom_products/colourways?product_code=" + custom_product_code;

    // Add the colourway code if we are requesting one specific colourway
    if (colourway_code) endpoint += "&colourway_code=" + colourway_code;

    // Call the API and return the full response
    const response = await strichCall("GET", endpoint, token);

    //debugLog("Get Custom Product Colourways Response:", response);

    return response;

}

// Add New Custom Product Colourway
export async function addCustomProductColourway(token, custom_product_code, colourway_data) {

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(colourway_data);

    // Call the API to add the colourway to the selected custom product
    const response = await strichCall("POST", "custom_products/colourways?product_code=" + custom_product_code, token, postdata);

    debugLog("Add Custom Product Colourway Response:", response, colourway_data);

    return response;

}

// Update Custom Product Colourway
export async function updateCustomProductColourway(token, custom_product_code, original_colourway_code, colourway_data) {

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(colourway_data);

    // Call the API using the original colourway code in the query string
    const response = await strichCall("POST", "custom_products/colourways?product_code=" + custom_product_code + "&colourway_code=" + original_colourway_code, token, postdata);

    debugLog("Update Custom Product Colourway Response:", response, colourway_data);

    return response;

}

// Delete Custom Product Colourway
export async function deleteCustomProductColourway(token, custom_product_code, colourway_code) {

    // Call the API to permanently delete the colourway
    const response = await strichCall("DELETE", "custom_products/colourways?product_code=" + custom_product_code + "&colourway_code=" + colourway_code, token);

    //debugLog("Delete Custom Product Colourway Response:", response);

    return response;

}


// Add New Custom Product Surface
export async function addCustomProductSurface(token, custom_product_code, surface_data) {

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(surface_data);
 
    const response = await strichCall("POST", "custom_products/surfaces?product_code=" + custom_product_code, token, postdata);

    //debugLog("Add New Custom Product SURFACE Response:", response);

    return response;

}

// Update Custom Product Surface
export async function updateCustomProductSurface(token, custom_product_code, original_surface_code, surface_data) {

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(surface_data);
 
    const response = await strichCall("POST", "custom_products/surfaces?product_code=" + custom_product_code + "&surface_code=" + original_surface_code, token, postdata);

    //debugLog("Updated Custom Product SURFACE Response:", response);

    return response;

}

// Delete Custom Product Surface
export async function deleteCustomProductSurface(token, custom_product_code, surface_code) {

    const response = await strichCall("DELETE", "custom_products/surfaces?product_code=" + custom_product_code + "&surface_code=" + surface_code, token);

    //debugLog("Delete Custom Product SURFACE Response:", response);

    return response;

}

// Add Custom Product Print Area
export async function addCustomProductPrintArea(token, custom_product_code, surface_code, print_area_data) {

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(print_area_data);
 
    const response = await strichCall("POST", "custom_products/print_areas?product_code=" + custom_product_code + "&surface_code=" + surface_code, token, postdata);

    //debugLog("Add New Custom Product PRINT AREA Response:", response);

    return response;

}

// Update Custom Product Print Area
export async function updateCustomProductPrintArea(token, custom_product_code, surface_code, original_print_area_code, print_area_data) {

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(print_area_data);

    //console.log("Update Print Area: ", postdata);
 
    const response = await strichCall("POST", "custom_products/print_areas?product_code=" + custom_product_code + "&surface_code=" + surface_code + "&print_area_code=" + original_print_area_code, token, postdata);

    //debugLog("Updated Custom Product PRINT AREA Response:", response);

    return response;

}

// Delete Custom Product Print Area
export async function deleteCustomProductPrintArea(token, custom_product_code, surface_code, print_area_code) {

    //console.log("(custom_product_code) to DELETE: ", custom_product_code);
    //console.log("SurfaceCode to DELETE: ", surface_code);

    const response = await strichCall("DELETE", "custom_products/print_areas?product_code=" + custom_product_code + "&surface_code=" + surface_code + "&print_area_code=" + print_area_code, token);

    //debugLog("Delete Custom Product PRINT AREA Response:", response);

    return response;

}

// Get Custom Product Print Area Roles
export async function getPrintAreaRoles(token) {

    const response = await strichCall("GET", "core/print_area_roles", token);

    //debugLog("Get Print Area Roles Response:", response);

    return response;

}


// Add or Update Custom Product Relative Position
export async function addUpdateRelativePosition(token, custom_product_code, surface_code, print_area_code, position_data) {

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(position_data);
 
    const response = await strichCall("POST", "custom_products/positions?product_code=" + custom_product_code + "&surface_code=" + surface_code + "&print_area_code=" + print_area_code, token, postdata);

    //debugLog("Updated Custom Product POSITION Response:", response);

    return response;

}

// Delete Custom Product Relative Position
export async function deleteRelativePosition(token, custom_product_code, surface_code, print_area_code, position_code) {
 
    const response = await strichCall("DELETE", "custom_products/positions?product_code=" + custom_product_code + "&surface_code=" + surface_code + "&print_area_code=" + print_area_code + "&position_code=" + position_code, token);

    //debugLog("Delete Custom Product POSITION Response:", response);

    return response;

}

// Update Custom Product View
export async function updateCustomProductView(token, custom_product_code, surface_code, print_area_code, view_style, view_name, view_data) {

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(Object.assign({}, view_data));

    // Build the endpoint using the existing view identity
    const endpoint = "custom_products/views?product_code=" + encodeURIComponent(custom_product_code) + "&surface_code=" + encodeURIComponent(surface_code) + "&print_area_code=" + encodeURIComponent(print_area_code) + "&style=" + encodeURIComponent(view_style) + "&name=" + encodeURIComponent(view_name);

    // Send the update request
    const response = await strichCall("PUT", endpoint, token, postdata);

    //debugLog("Updated Custom Product VIEW Response:", response);

    return response;

}

// Delete Custom Product View
export async function deleteCustomProductView(token, custom_product_code, surface_code, print_area_code, view_style, view_name) {

    // Build the endpoint using both parts of the view identity
    const endpoint = "custom_products/views?product_code=" + encodeURIComponent(custom_product_code) + "&surface_code=" + encodeURIComponent(surface_code) + "&print_area_code=" + encodeURIComponent(print_area_code) + "&style=" + encodeURIComponent(view_style) + "&name=" + encodeURIComponent(view_name);

    // Send the delete request
    const response = await strichCall("DELETE", endpoint, token);

    //debugLog("Delete Custom Product VIEW Response:", response);

    return response;

}

// Update Custom Product Mockup
export async function updateCustomProductMockup(token, custom_product_code, mockup_id, mockup_data) {

    // Convert the data to correct format for the call
    const postdata = JSON.stringify(Object.assign({}, mockup_data));

    // Build the endpoint for the selected mockup
    const endpoint = "custom_products/mockups?product_code=" + encodeURIComponent(custom_product_code) + "&mockup_id=" + encodeURIComponent(mockup_id);

    // Send the update request
    const response = await strichCall("PUT", endpoint, token, postdata);

    //debugLog("Updated Custom Product MOCKUP Response:", response);

    return response;

}


// Delete Custom Product Mockup
export async function deleteCustomProductMockup(token, custom_product_code, mockup_id) {
 
    const response = await strichCall("DELETE", "custom_products/mockups?product_code=" + custom_product_code + "&mockup_id=" + mockup_id, token);

    //debugLog("Delete Custom Product MOCKUP Response:", response);

    return response;

}

// Delete Custom Product Print Layout
export async function deleteCustomProductPrintLayout(token, custom_product_code, print_layout_id) {
 
    const response = await strichCall("DELETE", "custom_products/print_layouts?product_code=" + custom_product_code + "&print_layout_id=" + print_layout_id, token);

    //debugLog("Delete Custom Product PRINT LAYOUT Response:", response);

    return response;

}

// Update Print Layout
export async function updateCustomProductPrintLayout(token, print_layout_id, payload) {

    // Convert the data to correct format for the call
    const printLayoutPayload = JSON.stringify(Object.assign({}, payload))

    const response = await strichCall("PUT", "custom_products/print_layouts?print_layout_id=" + print_layout_id, token, printLayoutPayload);
   
    debugLog("Update Print Layout Response:", response, " Post Data: ", printLayoutPayload);

    // Include the product id in the repsonse
    return { ...response, id: printLayoutPayload.product_id };

}

// ********* Bits added by Ben


// Request PayPal link
export async function requestPayPalLink(token) {

    // Build the endpoint with the entered email
    const response = await strichCall("POST", "accounts/paypal_link", token);

    //debugLog("requestPayPalLink:", response);

    return response;

}


// Request PayPal unlink
export async function requestPayPalUnlink(token, email) {

    // Build the endpoint 
    const response = await strichCall("DELETE", "accounts/paypal_link", token);

    //debugLog("requestPayPalUnlink:", response);

    return response;

}

// Request PayPal billing link
export async function requestPayPalBillingLink(token) {

    let post_data = {};

    const response = await strichCall("POST", "accounts/paypal_billing_link", token, post_data);

    return response;
}


// Complete PayPal billing link
export async function completePayPalBillingLink(token, approval_token) {

    let post_data = {};

    const response = await strichCall("PUT", "accounts/paypal_billing_link?approval_token=" + approval_token, token, post_data);

    return response;
}


// Request PayPal billing unlink
export async function requestPayPalBillingUnlink(token) {

    const response = await strichCall("DELETE", "accounts/paypal_billing_link", token);

    return response;

}




// Request Stripe billing link
export async function requestStripeBillingLink(token) {

    let post_data = {};

    const response = await strichCall("POST", "accounts/stripe_billing_link", token, post_data);

    debugLog("Request Stripe Billing Link Response:", response);
    
    return response;

}

// Complete Stripe billing link
export async function completeStripeBillingLink(token, setup_intent_id) {

    let post_data = {};

    const response = await strichCall("PUT", "accounts/stripe_billing_link?setup_intent_id=" + setup_intent_id, token, post_data);

    debugLog("Complete Stripe Billing Link Response:", response);
    
    return response;

}

// Delete Stripe billing link (unlink)
export async function requestStripeBillingUnlink(token) {

    const response = await strichCall("DELETE", "accounts/stripe_billing_link", token);

    debugLog("Delete Stripe Billing Link Response:", response);

    return response;

}






// Get dashboard summary data
export async function getDashboardData(token) {

    const response = await strichCall("GET", "accounts/dashboard", token);

    debugLog("Get Dashboard Data Response:", response);

    return response;

}


// Custom Products //
